import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react'
import { Table, UnstyledButton, Group, Center } from '@mantine/core'

interface ThProps {
  children: React.ReactNode
  reversed?: boolean
  sorted?: boolean
  onSort?: () => void
  className?: string
  style?: Record<string, string>
  wrap?: boolean
}

export const Th = ({ children, reversed, sorted, onSort, className, style, wrap }: ThProps) => {
  const Icon = sorted ? (reversed ? IconChevronUp : IconChevronDown) : IconSelector
  const content = (
    <Group
      justify="flex-start"
      wrap={wrap ? 'wrap' : 'nowrap'}
      className={`${className || ''} w-full`}
    >
      <span className={wrap ? 'break-words whitespace-normal' : 'truncate'}>{children}</span>
      {onSort && (
        <Center className="flex-shrink-0">
          <Icon size={14} stroke={2} />
        </Center>
      )}
    </Group>
  )

  return (
    <Table.Th style={style}>
      {onSort ? (
        // Mantine's UnstyledButton hard-codes `font-size: md` (16px), which is
        // larger than the `Table.Th` cell default (`font-size: sm`, 14px) the
        // non-sortable headers inherit. Force inheritance so sortable and
        // non-sortable column headers render at the same size.
        <UnstyledButton
          onClick={onSort}
          className="w-full overflow-hidden"
          style={{ fontSize: 'inherit' }}
        >
          {content}
        </UnstyledButton>
      ) : (
        content
      )}
    </Table.Th>
  )
}
